import { Tabs } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SiteSettingsTab from "./site-settings/SiteSettingsTab";
import DatabaseResetTab from "./database/DatabaseResetTab"
import PrivacyTab from "./privacy/PrivacyTab";
import RequisitesTab from "./requisites/RequisitesTab";
import { IS_SUPER_ADMIN_KEY } from "../../../rest-api/queries/me";

export default function SettingsModal() {
  const { t } = useTranslation();
  const [, setActiveKey] = useState("siteSettings");
  // AccountAPI/Me dan keladi: IsSuperAdmin = RoleId == 1
  const isSuperAdmin = localStorage.getItem(IS_SUPER_ADMIN_KEY) === "1";
  return (
    <Tabs
      onChange={(key) => setActiveKey(key)}
      destroyInactiveTabPane
      defaultActiveKey="siteSettings"
      centered
    >
      <Tabs.TabPane key="siteSettings" tab={t("siteSettings")}>
        <SiteSettingsTab />
      </Tabs.TabPane>
      {/*
        Maxfiylik va hisob — HAMMA foydalanuvchiga ochiq.
        Play va App Store foydalanuvchining o'z hisobini o'chirish
        yo'lini majburiy talab qiladi; veb va mobil bir xil tizim
        bo'lgani uchun bu yerda ham bor.
      */}
      {/* Blankalar uchun korxona rekvizitlari (saqlashni server tekshiradi) */}
      <Tabs.TabPane key="requisites" tab={t("reqTab")}>
        <RequisitesTab />
      </Tabs.TabPane>
      <Tabs.TabPane key="privacy" tab={t("privacyTab")}>
        <PrivacyTab />
      </Tabs.TabPane>
      {/*
        Baza boshqaruvi — faqat Bosh Administratorga (rol 1).
        Ilgari bu yorliq HAMMAGA ochiq edi: menejer Sozlamalarni ochib,
        korxonaning butun baza statistikasini va "tozalash/qaytarish"
        tugmalarini ko'rardi. Amalning o'zi backendda rol 1 paroli bilan
        himoyalangan (ResetDatabase: Role != 1 -> rad etiladi), shuning
        uchun yorliqni ham aynan shu belgiga bog'ladik — hech kim
        haqiqiy imkoniyatdan mahrum bo'lmaydi.
      */}
      {isSuperAdmin && (
        <Tabs.TabPane key="database" tab="Baza Boshqaruvi">
          <DatabaseResetTab />
        </Tabs.TabPane>
      )}
    </Tabs>
  );
}
